var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.customer},[(!_vm.pendingTranslations)?_c('PurchasePage',{attrs:{"tabs":_vm.tabs}}):[_c('div',{staticClass:"loader"},[_c('span')])]],2)}
var staticRenderFns = []

export { render, staticRenderFns }